import React, {useState} from 'react';
import {INVOICE_PAGES} from "../JobOrderInvoicePage";
import {toast} from "react-toastify";
import Card from "../../components/Card";
import CreateEditInvoice from "../../components/job/invoice/CreateEditInvoice";

const JobOrderInvoiceCreateEditPage = (props) => {
    const {
        jobId           = null,
        orderId         = null,
        invoiceId       = null,
        parentId        = "",
        onChangePage    = (INDEX, invoice) => {}
    } = props;

    const handleClickBack = (event) => {
        event.preventDefault();
        onChangePage(INVOICE_PAGES.INDEX, null);
    }

    const handleCancel = () => {
        onChangePage(INVOICE_PAGES.INDEX, null);
    }

    const handleComplete = (invoice) => {
        if (!!invoiceId) {
            toast.success(<div>{"Invoice updated."}</div>);
        } else {
            toast.success(<div>{"Invoice created."}</div>);
        }

        onChangePage(INVOICE_PAGES.INDEX, null);
    }

    const handleDelete = () => {
        toast.success(<div>{"Invoice deleted."}</div>);

        onChangePage(INVOICE_PAGES.INDEX, null);
    }

    return (
        <React.Fragment>
            <Card
                title={!!invoiceId ? "Edit Invoice" : "Create Invoice"}
                classes={"mh-100 border-0"}
                controls={can('viewAny', 'invoice') ? (
                    <button
                        onClick={(event) => handleClickBack(event)}
                        className={"btn font-weight-bold btn-outline-eh-off-black px-4 m-0"}
                    >
                        <i className={"fa fa-chevron-left mr-2"} />
                        <span>{"Back"}</span>
                    </button>
                ) : null}
            >
                <CreateEditInvoice
                    jobId={jobId}
                    orderId={orderId}
                    invoiceId={invoiceId}
                    onCancel={() => handleCancel()}
                    onComplete={(invoice) => handleComplete(invoice)}
                    onDelete={() => handleDelete()}
                    parentId={parentId}
                />
            </Card>
        </React.Fragment>
    );
}

export default JobOrderInvoiceCreateEditPage;
